import { render, staticRenderFns } from "./QuotationDetails.vue?vue&type=template&id=03ce3ef4&"
import script from "./QuotationDetails.vue?vue&type=script&lang=js&"
export * from "./QuotationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports